module.exports = __webpack_public_path__ + "static/media/folder.3897a2b0.svg";